<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-align: center;">I would like to thank Amy Gill Yanofsky, Penny Fried, and Gina Farabelli Meyer. Thank you for pushing me to find direction in my life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?6f052dbc